import type {State} from 'src/reducers';
import type {DisplayConfig} from 'src/types/display-config';


export const selectDisplayConfig = (state: State): DisplayConfig =>
  state.displayConfig;

export const selectDisplayConfigByKey = (
  state: State,
  key: string,
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'DisplayConfig'.
): DisplayConfig => selectDisplayConfig(state)[key];

export const selectAbtEnabled = (state: State): DisplayConfig =>
  selectDisplayConfigByKey(state, 'list_abt_enabled');

export const selectJ2Enabled = (state: State): DisplayConfig =>
  selectDisplayConfigByKey(state, 'enable_workflow') ?? false;

export const selectJourneysEnabled = (state: State): DisplayConfig =>
  selectDisplayConfigByKey(state, 'show_journey_nav') ?? false;
